import { render, staticRenderFns } from "./ReformulacionDetallePage.vue?vue&type=template&id=17168700"
import script from "./ReformulacionDetallePage.js?vue&type=script&lang=js&external"
export * from "./ReformulacionDetallePage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports